import DashboardHero from "./DashboardHero";
import DashBoardsolutions from "./DashboardSolutions";

const DashboardBanner = () => {
  return (
    <div>
      {/* Our Solutions */}
      <div className="py-">
        <DashboardHero />
        <DashBoardsolutions />
      </div>
    </div>
  );
};

export default DashboardBanner;
